module.exports = __webpack_public_path__ + "static/BtnItch1-c58f9cbd4635f89a4ad054b7fa96f6f2.png";